import { SimplePage } from "@/app/_/marketing/SimplePage";
import { AgentOrchestration } from "@/app/_/sections/5AgentsSection/AgentOrchestration";
import AGENT_SCENARIO from "@/app/_/sections/5AgentsSection/agent-scenario";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="For finance & ops teams"
      title="Triage, workflows, and agents on your close checklist."
      subtitle="Work uncategorized transactions in a focused inbox, automate recurring review with workflows, and delegate reconciliation and reporting to agents that leave an audit trail."
      secondaryCta={{
        label: "Talk to us",
        to: "/company/contact",
      }}
      screenshot={{
        imageName: "triage-reconcile",
        alt: "Clearing the triage queue, then turning a merchant into a rule",
      }}
      capabilities={[
        {
          title: "Codify the checklist.",
          description:
            "Matching, splits, duplicates, transfers, and categorization run as rules on every new transaction — enabled per entity.",
          imageName: "crop-rules-table",
        },
        {
          title: "See exactly what a rule does.",
          description:
            "Each rule shows its trigger, conditions, and what it proposes, so a reviewer can trust it before it runs.",
          imageName: "crop-triage-suggestion",
        },
        {
          title: "An audit trail by construction.",
          description:
            "Every booking is a balanced journal entry with its source, so month-end review starts from evidence.",
          imageName: "crop-journal-entries",
        },
      ]}
      illustration={{
        title: "Delegate the close, keep the controls.",
        description:
          "Agents split reconciliation into steps and report back on each one. Nothing posts without the rules and reviews you set.",
        render: () => <AgentOrchestration scenario={AGENT_SCENARIO} />,
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/triage", "/platform/agents"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
